import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SocialLogin = () => {
  const navigate = useNavigate();
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      color: 'text-red-500',
      bgColor: 'hover:bg-red-50'
    },
    {
      id: 'linkedin',
      name: 'LinkedIn',
      icon: 'Linkedin',
      color: 'text-blue-600',
      bgColor: 'hover:bg-blue-50'
    }
  ];

  const handleSocialLogin = async (provider) => {
    setLoadingProvider(provider?.id);
    
    // Simulate social login
    setTimeout(() => {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userEmail', `user@${provider?.id}.com`);
      localStorage.setItem('userRole', 'user');
      navigate('/user-dashboard');
    }, 2000);
  };

  return (
    <div className="space-y-3">
      <div className="text-center">
        <p className="text-sm text-muted-foreground mb-4">Or continue with</p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.id}
            variant="outline"
            size="lg"
            fullWidth
            loading={loadingProvider === provider?.id}
            disabled={loadingProvider !== null}
            onClick={() => handleSocialLogin(provider)}
            className={`${provider?.bgColor} border-border`}
          >
            <div className="flex items-center justify-center space-x-3">
              <Icon 
                name={provider?.icon} 
                size={20} 
                className={provider?.color}
              />
              <span>Continue with {provider?.name}</span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialLogin;